const style = require('./pre-angular-view.css?raw');
const html = require('./pre-angular-view.html?raw');

export function initView(selector: string, logoSrc?: string): void {
  const el = document.querySelector(selector);
  const queryParams = location.search;
  if (el) {
    el.innerHTML = `
<style>
  ${typeof style === 'string' ? style : style.default}
</style>
${(typeof html === 'string' ? html : html.default)}
`;

    if (logoSrc) {
      el.querySelector("#logo").setAttribute('src', logoSrc);
    }

  } else {
    throw new Error('Invalid pre angular view selector: ' + selector);
  }
}

export function setInitLogo(selector: string, logoSrc: string): void {
  const el = document.querySelector(selector);
  el.querySelector("#logo").setAttribute('src', logoSrc);
}

/**
 * Removes some of the content used in the pre angular view.
 * Once disposed it can not revert.
 */
export function disposeView(): void {}

/**
 * Updates the message displayed to the user in the application load page.
 */
export function updateMessage(msg: string): void {
  if (document) {
    const el = document.querySelector('.pre-angular-root-container .wait-message');
    if (el) {
      el.innerHTML = msg;
    }
  }
}

export function displayError(errorMsg: string): void {
  if (document) {
    const elSpinner: HTMLElement = <any>document.querySelector('.pre-angular-root-container .spinner');
    if (elSpinner) {
      elSpinner.style.display = 'none';
    }

    const elMsg: HTMLElement = <any>document.querySelector('.pre-angular-root-container .wait-message');
    if (elMsg) {
      elMsg.classList.add('error-message');
      updateMessage(errorMsg);
    }
  }
}
